import * as settings from './theme-settings'
import * as colors from './theme-colors'
import * as typography from './theme-typography'
import { createTheme } from '@dooer/react-ui-kit'

const uiKitTheme = createTheme({
  settings,
  colors,
  typography,
})

export default uiKitTheme
